import { motion } from "framer-motion";
import Reveal from "../Reveal";
import SectionHead from "../SectionHead";

const IMG =
    "https://images.unsplash.com/photo-1720036236855-9a1a2e4d3f26?q=80&w=1400&auto=format&fit=crop";

const CAPABILITIES = [
    "FRP/GFRP Sheet Manufacturing",
    "Epoxy Fiberglass Components",
    "FRP Epoxy Boxes",
    "Electrical Insulation Components",
    "FRP Rods, Profiles & Strips",
    "FRP Washers & Rings",
    "Customized Machined FRP Components",
    "Drawing-Based Components",
    "Small & Batch Production",
    "Component Finishing & Inspection",
];

export const Profile = () => (
    <section id="profile" className="py-24 md:py-32 scroll-mt-20">
        <div className="shell">
            <SectionHead
                num="01"
                overline="Company Profile"
                title="Built for strength, insulation & precision"
                desc="Naagarjun Power Fiber is a manufacturer of FRP/GFRP sheets, epoxy fiberglass components and customized FRP components for electrical, transformer, industrial and engineering applications. We work with customers for both standard and customized components, based on approved drawings, specifications and application requirements."
            />

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
                <Reveal className="lg:col-span-5">
                    <div className="relative border border-zinc-800 group">
                        <img
                            src={IMG}
                            alt="Manufacturing floor"
                            className="w-full h-[320px] md:h-[480px] object-cover grayscale-[35%] group-hover:grayscale-0 transition-all duration-700"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#09090b]/85 via-transparent to-transparent" />
                        <div className="absolute bottom-0 inset-x-0 p-5 flex items-end justify-between">
                            <div>
                                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-safety">
                                    Manufacturing Floor
                                </div>
                                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400 mt-1">
                                    SIDA — Jaunpur, U.P. — India
                                </div>
                            </div>
                            <span className="chip-solid">FRP / GFRP</span>
                        </div>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.7, delay: 0.15 }}
                        className="mt-6 border border-zinc-800 bg-panel p-6"
                    >
                        <p className="text-zinc-300 text-sm leading-relaxed">
                            Our manufacturing approach focuses on{" "}
                            <span className="text-safety">dimensional accuracy</span>,{" "}
                            <span className="text-safety">mechanical strength</span>,{" "}
                            <span className="text-safety">electrical insulation performance</span>,{" "}
                            surface quality and consistent production.
                        </p>
                    </motion.div>
                </Reveal>

                <div className="lg:col-span-7">
                    <Reveal>
                        <h3 className="font-display text-2xl md:text-3xl font-semibold uppercase tracking-tight text-zinc-50 mb-8">
                            Our Core Capabilities
                        </h3>
                    </Reveal>
                    <div className="border-t border-zinc-800">
                        {CAPABILITIES.map((cap, i) => (
                            <motion.div
                                key={cap}
                                initial={{ opacity: 0, x: -24 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.5, delay: i * 0.05 }}
                                data-testid={`profile-capability-${i + 1}`}
                                className="group flex items-center gap-5 md:gap-8 py-4 md:py-5 border-b border-zinc-800 hover:bg-panel transition-colors duration-300 px-2 md:px-4"
                            >
                                <span className="font-mono text-xs text-safety w-8 shrink-0">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span className="font-display uppercase font-medium tracking-wide text-zinc-200 text-base md:text-xl group-hover:text-safety group-hover:translate-x-2 transition-all duration-300">
                                    {cap}
                                </span>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Profile;